
import { RequirementRule } from '../../domain.types';
import { GenericEntityMetadata, PropertyMetadata, TemporalType, nullIfContainsNull } from '@scisys-uim/uim-common';


export class AssetTypeMetadataBase extends GenericEntityMetadata {
  constructor() {
    super('AssetType', {
      assetTypeId: <PropertyMetadata> {
        name: 'assetTypeId',
        type: 'number',
        plural: false,
        isIdentity: true,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      comments: <PropertyMetadata> {
        name: 'comments',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 2000,
        unique: false
      },
      createdBy: <PropertyMetadata> {
        name: 'createdBy',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      createdDate: <PropertyMetadata> {
        name: 'createdDate',
        type: 'Date',
        temporalType: TemporalType.TIMESTAMP,
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      electricalAspectRequirement: <PropertyMetadata> {
        name: 'electricalAspectRequirement',
        type: 'RequirementRule',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 11,
        unique: false
      },
      guidanceText: <PropertyMetadata> {
        name: 'guidanceText',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      havs: <PropertyMetadata> {
        name: 'havs',
        type: 'boolean',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 1,
        unique: false
      },
      havsRagStatus: <PropertyMetadata> {
        name: 'havsRagStatus',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 1,
        unique: false
      },
      lockVersion: <PropertyMetadata> {
        name: 'lockVersion',
        type: 'number',
        plural: false,
        isIdentity: false,
        derived: true,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      maintenanceAspectRequirement: <PropertyMetadata> {
        name: 'maintenanceAspectRequirement',
        type: 'RequirementRule',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 11,
        unique: false
      },
      maintenanceType: <PropertyMetadata> {
        name: 'maintenanceType',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      mechanicalAspectRequirement: <PropertyMetadata> {
        name: 'mechanicalAspectRequirement',
        type: 'RequirementRule',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 11,
        unique: false
      },
      name: <PropertyMetadata> {
        name: 'name',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      periodicMaintenance: <PropertyMetadata> {
        name: 'periodicMaintenance',
        type: 'boolean',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 1,
        unique: false
      },
      periodicMaintenanceDays: <PropertyMetadata> {
        name: 'periodicMaintenanceDays',
        type: 'number',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      portableApplianceTestingDays: <PropertyMetadata> {
        name: 'portableApplianceTestingDays',
        type: 'number',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      routineMaintenance: <PropertyMetadata> {
        name: 'routineMaintenance',
        type: 'boolean',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 1,
        unique: false
      },
      routineMaintenanceDays: <PropertyMetadata> {
        name: 'routineMaintenanceDays',
        type: 'number',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      transferOnApproval: <PropertyMetadata> {
        name: 'transferOnApproval',
        type: 'boolean',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 1,
        unique: false
      },
      updatedBy: <PropertyMetadata> {
        name: 'updatedBy',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 255,
        unique: false
      },
      updatedDate: <PropertyMetadata> {
        name: 'updatedDate',
        type: 'Date',
        temporalType: TemporalType.TIMESTAMP,
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        unique: false
      },
      visualInspection: <PropertyMetadata> {
        name: 'visualInspection',
        type: 'boolean',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 1,
        unique: false
      },
      wbv: <PropertyMetadata> {
        name: 'wbv',
        type: 'boolean',
        plural: false,
        isIdentity: false,
        derived: false,
        required: true,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 1,
        unique: false
      },
      wbvRagStatus: <PropertyMetadata> {
        name: 'wbvRagStatus',
        type: 'string',
        plural: false,
        isIdentity: false,
        derived: false,
        required: false,
        readOnly: false,
        readable: true,
        writeable: true,
        length: 1,
        unique: false
      }
    });
  }
  toKeyObject(item: any): any {
    const result = item?.assetTypeId;
    return nullIfContainsNull(result);
  }
}



